import React from "react";

const TermsOfService = () => {
  return (
    <>
      {/* Hero Section */}
      <section
        className="position-relative"
        style={{
          height: "280px",
          backgroundImage: "url('/images/terms-condition.jpg')", // Replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background: "rgba(0,0,0,0.35)",
          }}
        ></div>

        <div className="container h-100 position-relative">
          <div className="row h-100 align-items-end">
            <div className="col-12 pb-5">
              <h2 className="text-white fw-normal">Terms of Service</h2>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="bg-white p-lg-5 p-4 shadow-sm">
                <h6 className="fw-bold mb-4">Welcome to Save Hornbills.</h6>

                <p>
                  These Terms of Service govern your use of the Save Hornbills
                  website and its related content, resources, and services.
                </p>

                <p>
                  By accessing or using this website, you agree to these terms.
                </p>

                <h6 className="fw-bold mt-4">1. Purpose of the Website</h6>

                <p>
                  Save Hornbills is an awareness and conservation-focused
                  platform dedicated to sharing information about endangered
                  bird species, habitat protection, conservation initiatives,
                  and educational resources.
                </p>

                <p>
                  The website may also direct visitors to external
                  organizations, educational resources, and donation platforms
                  supporting wildlife conservation.
                </p>

                <h6 className="fw-bold mt-4">2. Use of Website</h6>

                <p>You agree to use this website responsibly and lawfully.</p>

                <p>You may not:</p>

                <ul>
                  <li>Use the website for illegal activities</li>
                  <li>Attempt to disrupt or damage the website</li>
                  <li>Copy or misuse content without permission</li>
                  <li>Upload harmful software or malicious code</li>
                  <li>Misrepresent your identity or affiliation</li>
                </ul>

                <p>
                  We reserve the right to restrict access to users who violate
                  these terms.
                </p>

                <h6 className="fw-bold mt-4">
                  3. External Organizations & Donations
                </h6>

                <p>
                  Some pages may include links to external conservation groups,
                  donation portals, or fundraising platforms.
                </p>

                <p>
                  Save Hornbills does not directly process donations unless
                  explicitly stated.
                </p>

                <p>We are not responsible for:</p>

                <ul>
                  <li>Third-party payment processing</li>
                  <li>External organization policies</li>
                  <li>Donation disputes</li>
                  <li>External website content</li>
                </ul>

                <p>
                  Users should independently review the policies and credibility
                  of any organization before donating.
                </p>

                <h6 className="fw-bold mt-4">4. Content Accuracy</h6>

                <p>
                  We strive to provide accurate and updated conservation
                  information.
                </p>

                <p>However:</p>

                <ul>
                  <li>Wildlife statistics may change over time</li>
                  <li>Conservation data may evolve</li>
                  <li>Some content may contain unintentional inaccuracies</li>
                  <li>
                    The website content is provided for informational and
                    educational purposes only
                  </li>
                </ul>

                <h6 className="fw-bold mt-4">5. Intellectual Property</h6>

                <p>All original website content including:</p>

                <ul>
                  <li>Text</li>
                  <li>Branding</li>
                  <li>Design elements</li>
                  <li>Graphics</li>
                  <li>Logos</li>
                  <li>Written material</li>
                </ul>

                <p>
                  is protected by applicable copyright and intellectual property
                  laws unless otherwise credited.
                </p>

                <p>
                  You may not reproduce or commercially distribute website
                  content without prior written permission.
                </p>

                <h6 className="fw-bold mt-4">6. Limitation of Liability</h6>

                <p>Save Hornbills is provided on an “as is” basis.</p>

                <p>We are not liable for:</p>

                <ul>
                  <li>Website interruptions</li>
                  <li>External link issues</li>
                  <li>Technical errors</li>
                  <li>Data loss</li>
                  <li>Damages resulting from website use</li>
                </ul>

                <p>
                  Users access the website at their own discretion and risk.
                </p>

                <h6 className="fw-bold mt-4">7. Changes to These Terms</h6>

                <p>
                  We may update these Terms of Service at any time without prior
                  notice.
                </p>

                <p>
                  Continued use of the website after updates means you accept
                  the revised terms.
                </p>

                <h6 className="fw-bold mt-4">8. Governing Principles</h6>

                <p>
                  These terms are intended to support ethical website use,
                  wildlife conservation awareness, and responsible online
                  engagement.
                </p>

                <h6 className="fw-bold mt-4">9. Contact</h6>

                <p>
                  For questions regarding these Terms of Service, please contact
                  us through the website contact section.
                </p>

                <p>
                  Thank you for supporting conservation efforts and helping
                  protect endangered hornbill species for future generations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfService;